// extracted by mini-css-extract-plugin
module.exports = {"slidefooter":"slidefooter--14g1F","reset":"reset--2Xz7_","confirm":"confirm--2789G"};